/// <summary>
/// This object provides client-side functions for picking dates. You can pick single dates and ranges. Therefore you have to add parameters, when you initialice the widget. 
/// Everytime you init a vcDate you have to add the Intervall and the Modus parameter, cause else you would get a empty widget with an error message.
/// There are tree intervals 1: Select a Day, 3: Select a Month, 5: Select a Year; There also are two Modus Single: Select just one date, Range: Typical From - To date selection.
/// To get the Date you just have to call the getDate() for Single Modus and the getRange() Function for Modus Range. getDate() will return a single date in String format and getRange() will return a object contins a from and a to property.
/// Over the LangID(optional parameter) you can select the language if you don't add the parameter the language will be german.
/// If you set the DefaultDate the widget will have the DefaultDate set, for the Range Modus same thing only you have to set the DefaultRange{From , To}.
/// For your own sake please never change the position from the me._initDate() Calls.
/// One last problem: the generic lists year and month events call over a selector which calls all lists classes and if you have more instances of the same interval containing those lists only the first list will set each of the same lists.
/// The Option DateFormat must be reworked, cause of moment uses two date formats one in it's contructor and one in method .format() and in Modus Single you use other formats for each interval like 17.11.2017, 11.2017 and 2017 you should think over this.
/// Important CSS Classes: .ul-dropdown, .ul-dropdown-li + Selectors, .ul-month, .ul-year, .div-widget, the region PRESET STYLES on testflorian.aspx and the region Colors on testflorian.aspx.
/// Quick tips for moment.js:
/// 1. every time you have to start with moment(Date you want, Format).
/// 2. if you want to add a day, month or year just append .add(Amount, Part from Format you wish to add example: "M" for Month).
/// 3. to get just the day append .date() for month .month() and for year .year().
/// 4. if you want a date object from moment append .toDate(), with specific format append behind .format().
/// 5. For start of year or month or week append .startOf(Part from Format you wish to add example: "M" for Month) for end of year ..... append .endOf(Part from Format you wish to add example: "M" for Month).
/// 6. Weeks are strange so every time you use startOf or endOf week and you use week(depends on local time settings) not isoweek(takes utc norms) you have to add a day to start and end 
/// <br/>
/// Author: FWO<br />
/// Date: 17.11.2017<br />
/// Copyright ©: EUDT GmbH 2017 <br />
/// Version-HiTory:<br />
/// **********************************************************************<br />
/// *** v1.1.0 - 11.03.2020                                              *<br />
/// **********************************************************************<br />
/// * - added time-dropdowns for interval 1 in single and range mode     *<br />
/// * - time is returned in the same object as in the getDate method     *<br />
/// **********************************************************************<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 17.11.2017                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.vcDate",
{

    self: null,
    bActiveCallback: true,

    resources: window.__DateResources,

    _getResources: function () {
        return this.resources[this.options.langID - 2];        
    },

    getDateResources: function () {
        return this._getResources();
    },

    

    options: {
        returnDates: { from: null, to: null },
        defaultDate: null,
        defaultDateTime: null,
        defaultRange: { from: null, to: null },
        defaultTime: { from: null, to: null },
        singleDate: null,
        singleDateTime: null,
        dateRange: {
            from: null,
            to: null,
            time: { from: null, to: null }
        },
        dateTimeRange: { from: null, to: null },
        mode: "Range",
        interval: 0,
        langID: 2,
        useNavigation: true,
        dateFormat: 'dd.MM.yy',
        align: "Center"

    },

    _destroy: function () {

        this.element
            .removeClass("vc-date")
            .html("");


        // remove all eventListeners
        $('body').off(this.eventNamespace); // remove all body event listeners
        $('body').off("click" + this.eventNamespace); // remove all click event listeners on body
        $(document).off("click" + this.eventNamespace); // remove all click event listeners on document
        $(this.element).off(); // remove all event listeners on element
        $(this).off(this.eventNamespace);

        // remove jQuery data cache
        this.element.removeData(this.eventNamespace).remove(this.eventNamespace);


        // TODO MKU: this solution is not working for vcDate; other vcDate instances are influenced, if one instance is destroyed!
        // check for reasons and other solutions!

       //// iterate all properties of this and remove everything and set it to null
       //for (var key in this) {
       //    if (this.hasOwnProperty(key)) {

       //        if (this[key] && this[key].removeData) {
       //            $(this[key]).removeData().remove();
       //        }
       //        this[key] = null; // set reference to null

       //    }
        //}
                

       //// set bindings and element to nulls
       //this.bindings = null;
       //this.element = null;
 
    },   

    _create: function () {


        this.element.removeClass("vc-date").addClass("vc-date");
        if (this.options.time && this.options.interval === 1) { this.element.removeClass("time").addClass("time"); }

        self = this;
        var me = this;
        //##################### WIDGET ######################

        me.divWidget = $("<div>").addClass("div-widget");
        //##################### ICONS #######################

        me.pDivText = $("<p>").addClass("p-displaytext p-divtext");
        me.calenderIcon = $("<span>").addClass("calender-icon").html("<i class='fa-regular fa-calendar' aria-hidden='true'></i>");
        me.iArrowLeft = $("<i>").addClass("fa-regular fa-circle-left fa-2x icon-nav");
        me.iArrowRight = $("<i>").addClass("fa-regular fa-circle-right fa-2x icon-nav");
        
        //##################### NAVIGATION #######################
        me.divNext = $("<div>").addClass("vertical navigate");
        me.divPrevious = $("<div>").addClass("vertical navigate");

        //##################### DROP DOWN ###################
        me.ulMenue = $("<ul>").addClass("ul-menue");
        me.liLeft = $("<li>").addClass("ul-menue-li");
        me.liContent = $("<li>").addClass("li-content ul-menue-li");
        me.liRight = $("<li>").addClass("ul-menue-li");
        me.dropdowndiv = $("<div>").addClass("div-dropdown");
        me.divDopDownText = $("<div>").addClass("div-dropdowntext vertical");

        me.divRange = $("<div>").addClass("div-range");
        me.divRangeHeader = $("<div>").addClass("div-range-header");
        me.Break = $("<br>");
        me.divClear = $("<div>").addClass("div-Clear");

        me.dropdownUL = $("<ul>").addClass("ul-dropdown color-background-grey");

        me.pErrorInput = $("<p>").addClass("p-errorinput").html(this._getResources().errorinput);

        switch (this.options.align.toLowerCase()) {
            case "left":
                me.dropdownUL.addClass("align-left");
                break;
            case "center":
                me.dropdownUL.addClass("align-middle");
                break;
            case "right":
                me.dropdownUL.addClass("align-right");
                break;

            default:
        }

        var i;
        switch (this.options.mode) {

            case "Single":

                me._initDate();

                //##################### LIST ITEMS ##################
                //There must be ids
                me.liToday = $("<li>").attr("id", "li-today").data("date", me._setToday())
                    .addClass("ul-dropdown-li  button-toggle");
                me.liYesterday = $("<li>").attr("id", "li-yesterday").data("date", me._setYesterday())
                    .addClass("ul-dropdown-li  button-toggle");
                me.liDayBeforeYesterday = $("<li>").attr("id", "li-daybeforeyesterday")
                    .data("date", me._setDayBeforeYesterday()).addClass("ul-dropdown-li button-toggle");
                me.licustom = $("<li>").attr("id", "li-custom").addClass("color-background-lightgrey ul-dropdown-li");

                switch (this.options.interval) {

                    case 1:
                        me.dateInput = $("<input>").addClass("input-date txtEnabled").attr("placeholder", "TT.MM.JJJJ");

                        //##################### PARAGRAPHS ##################
                        me.pToday = $("<p>").addClass("p-displaytext").html(this._getResources().today);
                        me.pDivText.html(this._getResources().today);
                        me.pYesterday = $("<p>").addClass("p-displaytext").html(this._getResources().yesterday);
                        me.pDayBeforeYesterday = $("<p>").addClass("p-displaytext")
                            .html(this._getResources().daybeforeyesterday);


                        //##################### CUSTOM ######################

                        me.divcustom = $("<div>").addClass("div-custom");

                        me.divcustomPicker = $("<div>").addClass("div-custompicker").datepicker({
                            changeMonth: true,
                            changeYear: true,
                            showButtonPanel: true,
                            dateFormat: 'dd.mm.yy'
                        });

                        me.divcustomInput = $("<div>").addClass("div-custominput");
                        me.divcustomApply = $("<div>").addClass("div-customapply").html(this._getResources().take).button();

                        //###################################################

                        //##################### APPEND AREA #################

                        me.divDopDownText.append(me.pDivText, me.calenderIcon);
                        me.dropdowndiv.append(me.divDopDownText);

                        me.divNext.append(me.iArrowRight);
                        me.divPrevious.append(me.iArrowLeft);

                        if (this.options.useNavigation === true) {
                            me.liLeft.append(me.divPrevious);
                            me.liContent.append(me.dropdowndiv);
                            me.liRight.append(me.divNext);
                        } else {
                            me.liContent.append(me.dropdowndiv);
                        }

                        me.ulMenue.append(me.liLeft, me.liContent, me.liRight);

                        //Custom Div Content
                        me.divcustomInput.append(me.dateInput);

                        if (me.options.time) {
                            if (me.options.minuteInterval === undefined) me.options.minuteInterval = 1;

                            me.timeDropdown = $("<input type='time' class='txtEnabled' value='00:00' style='height:29px'>");
                        
                            me.timeDropdownTime = "00:00";

                            me.divcustomInput.addClass("time");
                            me.divcustomInput.append(
                                me.timeDropdown.clone().addClass("select-time single"),
                                $("<div>", { "style": "clear: both;" })
                            );
                        }

                        me.divcustomInput.append(me.divcustomApply);

                        //Add Paragraphs
                        me.liToday.append(me.pToday);
                        me.liYesterday.append(me.pYesterday);
                        me.liDayBeforeYesterday.append(me.pDayBeforeYesterday);

                        //custom Item for Dropdown UL
                        me.licustom.append(me.divcustom, me.divcustomInput, me.divcustomPicker);

                        me.dropdownUL.append(me.liToday, me.liYesterday, me.liDayBeforeYesterday, me.licustom);


                        //Append to Widget
                        me.divWidget.append(me.ulMenue);
                        me.element.append(me.divWidget);
                        me.element.append(me.dropdownUL);
                        me._updateDate(me.options.singleDate);
                        //###################################################
                        break;

                    case 3:

                        //##################### PARAGRAPHS ##################

                        me.pToday = $("<p>").addClass("p-displaytext").html(this._getResources().thismonth);
                        me.pDivText.html(this._getResources().thismonth);
                        me.pYesterday = $("<p>").addClass("p-displaytext").html(this._getResources().lastmonth);
                        me.pDayBeforeYesterday = $("<p>").addClass("p-displaytext")
                            .html(this._getResources().monthbeforelastmonth);
                        me.pMonth = $("<p>").addClass("p-displaytext vertical p-month").html(this._getResources().month);
                        me.pYear = $("<p>").addClass("p-displaytext vertical p-year").html(this._getResources().year);

                        //##################### CUSTOM ######################

                        me.divcustomtext = $("<div>").addClass("div-customtext");
                        me.divcustom = $("<div>").addClass("div-custom");
                        me.divcustomApply = $("<div>").addClass("div-button-month").html(this._getResources().take).button();

                        me.ulmonth = $("<ul>").addClass("ul ul-month-base ul-month vertical");
                        me._fillMonthDdl(me.ulmonth, "ul-month-li");

                        me.ulyear = $("<ul>").addClass("ul ul-year-base ul-year vertical");
                        this._fillYearDdl(me.ulyear, me.options.singleDate, "DD.MM.YYYY", "ul-year-li");

                        //##################### APPEND AREA #################

                        me.divDopDownText.append(me.pDivText, me.calenderIcon);
                        me.dropdowndiv.append(me.divDopDownText);

                        me.divNext.append(me.iArrowRight);
                        me.divPrevious.append(me.iArrowLeft);

                        if (this.options.useNavigation === true) {
                            me.liLeft.append(me.divPrevious);
                            me.liContent.append(me.dropdowndiv);
                            me.liRight.append(me.divNext);
                        } else {
                            me.liContent.append(me.dropdowndiv);
                        }

                        me.ulMenue.append(me.liLeft, me.liContent, me.liRight);

                        //Custom Div Content

                        //Add Paragraphs
                        me.liToday.append(me.pToday);
                        me.liYesterday.append(me.pYesterday);
                        me.liDayBeforeYesterday.append(me.pDayBeforeYesterday);

                        me.divcustomtext.append("<br/>", me.divcustomApply);
                        me.divcustom.append(me.ulmonth, me.ulyear);

                        //custom Item for Dropdown UL

                        me.licustom.append(me.divcustomtext);

                        me.licustom.append(me.divcustom, $("<div>").css("clear", "both"));

                        //Add List Items to Dropdown UL
                        me.dropdownUL.append(me.liToday, me.liYesterday, me.liDayBeforeYesterday, me.licustom);

                        //Initial Entry for SingleDate

                        //Append to Widget

                        me.divWidget.append(me.ulMenue);
                        me.element.append(me.divWidget);
                        me.element.append(me.dropdownUL);
                        me._updateDate(me.options.singleDate);
                        $(me.ulmonth).find(':nth-child(' + (moment(me.options.singleDate, "DD.MM.YYYY").month() + 1) + ')')
                            .addClass("color-bg-primary");
                        $(me.ulyear).find('[value = ' + (moment(me.options.singleDate, "DD.MM.YYYY").year()) + ']')
                            .addClass("color-bg-primary");

                        //###################################################
                        break;

                    case 5:


                        //##################### PARAGRAPHS ##################
                        me.pToday = $("<p>").addClass("p-displaytext").html(this._getResources().thisyear);
                        me.pDivText.html(this._getResources().thisyear);
                        me.pYesterday = $("<p>").addClass("p-displaytext").html(this._getResources().lastyear);
                        me.pDayBeforeYesterday = $("<p>").addClass("p-displaytext")
                            .html(this._getResources().yearbeforelastyear);


                        //##################### CUSTOM ######################

                        me.divcustom = $("<div>").addClass("div-custom");
                        me.ulyear = $("<ul>").addClass("ul ul-year-base vertical custom-mode-single-interval-5 ul-year");
                        this._fillYearDdl(me.ulyear, me.options.singleDate, "YYYY", "ul-year-li");

                        //###################################################

                        //##################### APPEND AREA #################

                        me.divDopDownText.append(me.pDivText, me.calenderIcon);
                        me.dropdowndiv.append(me.divDopDownText);

                        me.divNext.append(me.iArrowRight);
                        me.divPrevious.append(me.iArrowLeft);

                        if (this.options.useNavigation === true) {
                            me.liLeft.append(me.divPrevious);
                            me.liContent.append(me.dropdowndiv);
                            me.liRight.append(me.divNext);
                        } else {
                            me.liContent.append(me.dropdowndiv);
                        }

                        me.ulMenue.append(me.liLeft, me.liContent, me.liRight);

                        //Add Paragraphs
                        me.liToday.append(me.pToday);
                        me.liYesterday.append(me.pYesterday);
                        me.liDayBeforeYesterday.append(me.pDayBeforeYesterday);

                        me.divcustom.append("<br/>", me.ulyear);

                        //custom Item for Dropdown UL
                        me.licustom.append(me.divcustom);

                        //Add List Items to Dropdown UL
                        me.dropdownUL.append(me.liToday, me.liYesterday, me.liDayBeforeYesterday, me.licustom);

                        //Append to Widget

                        me.divWidget.append(me.ulMenue);
                        me.element.append(me.divWidget);
                        me.element.append(me.dropdownUL);
                        
                        me._updateDate(me.options.singleDate);


                        $(me.ulyear).find('[value = ' + (moment(me.options.singleDate, "YYYY").year()) + ']')
                            .addClass("color-bg-primary");

                        $(me.ulyear).scrollTop(200);

                        //###################################################

                        break;

                    default:
                        break;
                }
                break;

            case 'Range':
                switch (this.options.interval) {

                    case 1:

                        //##################### PARAGRAPHS ##################

                        me.pThisWeek = $("<p>").addClass("p-displaytext").html(this._getResources().thisweek);
                        me.pLastWeek = $("<p>").addClass("p-displaytext").html(this._getResources().lastweek);

                        me.pWeekofYear = $("<p>").addClass("p-displaytext vertical").html(this._getResources().weekofyear);
                        me.pThisMonth = $("<p>").addClass("p-displaytext").html(this._getResources().thismonth);
                        me.pLastMonth = $("<p>").addClass("p-displaytext").html(this._getResources().lastmonth);
                        me.pThisYear = $("<p>").addClass("p-displaytext").html(this._getResources().thisyear);
                        me.pLastYear = $("<p>").addClass("p-displaytext").html(this._getResources().lastyear);
                        //me.pLastSevenDays = $("<p>").addClass("p-displaytext").html(this._getResources().lastsevenyears);
                        //me.pLastFourteenDays = $("<p>").addClass("p-displaytext").html(this._getResources().lastfourteendaies);

                        me.pStartRange = $("<p>").addClass("p-range p-StartRange").html(this._getResources().from);
                        me.pEndRange = $("<p>").addClass("p-range p-EndRange").html(this._getResources().to);
                        me.inputStartRange = $("<input>").addClass("input-StartRange input-date txtEnabled")
                            .attr("type", "text").attr("placeholder", "TT.MM.JJJJ");
                        me.inputEndRange = $("<input>").addClass("input-EndRange  input-date txtEnabled").attr("type", "text")
                            .attr("placeholder", "TT.MM.JJJJ");;

                        //##################### DROP DOWN ###################

                        me.dropdownUL.addClass("range-day");

                        //##################### LIST ITEMS ##################

                        //There must be ids

                        me.liThisWeek = $("<li>").attr("id", "li-thisweek").addClass("ul-dropdown-li button-toggle li-floatleft")
                            .data("nav", { modus: "week", interval: 1 });
                        me.liLastWeek = $("<li>").attr("id", "li-lastweek").addClass("ul-dropdown-li button-toggle  li-floatright")
                            .data("nav", { modus: "week", interval: 1 });
                        //me.liLastSevenDays = $("<li>").attr("id", "li-lastsevendaies")
                        //    .addClass("ul-dropdown-li button-toggle   li-floatleft")
                        //    .data("nav", { modus: "days", interval: 7 });
                        //me.liLastFourteenDays = $("<li>").attr("id", "li-lastfourteendaies")
                        //    .addClass("ul-dropdown-li button-toggle  li-floatright")
                        //    .data("nav", { modus: "days", interval: 14 });

                        me.liThisMonth = $("<li>").attr("id", "li-thismonth").addClass("ul-dropdown-li button-toggle   li-floatleft")
                            .data("nav", { modus: "M", interval: 1 });

                        me.liLastMonth = $("<li>").attr("id", "li-lastmonth").addClass("ul-dropdown-li button-toggle   li-floatright")
                            .data("nav", { modus: "M", interval: 1 });
                        me.liThisYear = $("<li>").attr("id", "li-thisyear").addClass("ul-dropdown-li button-toggle li-floatleft")
                            .data("nav", { modus: "Y", interval: 1 });
                        me.liLastYear = $("<li>").attr("id", "li-lastyear").addClass("ul-dropdown-li button-toggle li-floatright")
                            .data("nav", { modus: "Y", interval: 1 });

                        me.liWeekofYear = $("<li>").attr("id", "li-weekofyear")
                            .addClass("ul-dropdown-li color-background-lightgrey").css("cursor", "default")
                            .hover(function () { $(this).css("background-color", "#f7f4f4") });
                        //me.inputWeekofYear = $("<input>").attr("type", "number")
                        //    .addClass("input-weekofyear txtEnabled vertical");
                        me.liRange = $("<li>").attr("id", "li-range").addClass("ul-dropdown-li color-background-lightgrey");


                        //##################### CUSTOM ######################

                        me.divcustom = $("<div>").addClass("div-custom");
                        me.divcustomInput = $("<div>").addClass("div-custominput");
                        me.divcustomApply = $("<div>").addClass("div-buttonweekofyear").html(this._getResources().from).button();

                        //###################################################

                        me.divPickRangeStart = $("<div>").addClass("div-PickRange div-PickRangeStart vertical").datepicker({
                            changeMonth: true,
                            changeYear: true,
                            showWeek: true,
                            firstDay: 1,
                            showButtonPanel: true,
                            dateFormat: 'dd.mm.yy'
                        });

                        me.divPickRangeEnd = $("<div>").addClass("div-PickRange div-PickRangeEnd vertical").datepicker({
                            changeMonth: true,
                            changeYear: true,
                            showWeek: true,
                            firstDay: 1,
                            showButtonPanel: true,
                            dateFormat: 'dd.mm.yy'
                        });

                        me.divbuttoncustomrange = $("<div>").addClass("div-buttoncustomrange").html(this._getResources().takeDateSelection).button();

                        //##################### APPEND AREA #################

                        me.divDopDownText.append(me.pDivText, me.calenderIcon);
                        me.dropdowndiv.append(me.divDopDownText);

                        me.divNext.append(me.iArrowRight);
                        me.divPrevious.append(me.iArrowLeft);

                        if (this.options.useNavigation === true) {
                            me.liLeft.append(me.divPrevious);
                            me.liContent.append(me.dropdowndiv);
                            me.liRight.append(me.divNext);
                        } else {
                            me.liContent.append(me.dropdowndiv);
                        }

                        me.ulMenue.append(me.liLeft, me.liContent, me.liRight);

                        //Custom Div Content
                        // me.divcustomInput.append(me.dateInput, me.divcustomApply);

                        //Add Paragraphs
                        me.liThisWeek.append(me.pThisWeek);
                        me.liLastWeek.append(me.pLastWeek);
                        ////me.liWeekBefore.append(me.pWeekBefore);
                        //me.liWeekofYear.append(me.pWeekofYear, me.inputWeekofYear, me.divcustomApply);
                        me.liThisMonth.append(me.pThisMonth);
                        me.liLastMonth.append(me.pLastMonth);
                        me.liThisYear.append(me.pThisYear);
                        me.liLastYear.append(me.pLastYear);
                        //me.liMonthBefore.append(me.pMonthBefore);
                        //me.liLastSevenDays.append(me.pLastSevenDays);
                        //me.liLastFourteenDays.append(me.pLastFourteenDays);
                        //me.liLastThirtyDays.append(me.pLastThirtyDays);

                        ////Range
                        //me.divRangeHeader.append(
                        //    me.divbuttoncustomrange,
                        //    $("<div>").css("clear", "both"),
                        //    me.pStartRange,
                        //    me.inputStartRange,
                        //    me.pEndRange,
                        //    me.inputEndRange
                        //);
                        //Range
                        me.divRangeHeader.append(
                            me.divbuttoncustomrange,
                            $("<div>").css("clear", "both"),
                            me.pStartRange,
                            me.inputStartRange,
                            me.pEndRange,
                            me.inputEndRange,
                            $("<div>").css("clear", "both")
                        );

                        if (me.options.time) {
                            if (me.options.minuteInterval === undefined) me.options.minuteInterval = 1;

                            me.timeDropdown = $("<select>");

                            me.timeDropdownTime = "00:00";

                            for (i = 0; me.timeDropdownTime.split(":")[0] !== "24"; i++) {
                                me.timeDropdown.append(
                                    $("<option>")
                                        .val(me.timeDropdownTime)
                                        .html(me.timeDropdownTime)
                                );

                                me.timeDropdownHour = me.timeDropdownTime.split(":")[0];
                                me.timeDropdownMinute = me.timeDropdownTime.split(":")[1];

                                if (parseInt(me.timeDropdownMinute) + me.options.minuteInterval >= 60) {
                                    me.timeDropdownMinute = "00";
                                    me.timeDropdownHour = (parseInt(me.timeDropdownHour) + 1).toString();
                                } else {
                                    me.timeDropdownMinute = (parseInt(me.timeDropdownMinute) + me.options.minuteInterval).toString();
                                }

                                while (me.timeDropdownHour.length < 2) {
                                    me.timeDropdownHour = "0" + me.timeDropdownHour;
                                }
                                while (me.timeDropdownMinute.length < 2) {
                                    me.timeDropdownMinute = "0" + me.timeDropdownMinute;
                                }

                                me.timeDropdownTime = me.timeDropdownHour + ":" + me.timeDropdownMinute;
                            }

                            me.divRangeHeader.append(
                                me.timeDropdown.clone().addClass("select-time from"),
                                me.timeDropdown.clone().addClass("select-time to")
                            );
                        }

                        me.divRange.append(me.divRangeHeader, me.divPickRangeStart, me.divPickRangeEnd);
                        me.liRange.append(me.divRange);

                        //Add List Items to Dropdown UL
                        me.dropdownUL.append(me.liThisWeek, me.liLastWeek, me.liLastSevenDays, me.liLastFourteenDays,
                            me.liThisMonth, me.liLastMonth, me.liThisYear, me.liLastYear,
                            $("<div>").css("clear", "both"),
                            me.liRange);

                        //Append to Widget

                        me.divWidget.append(me.ulMenue);
                        me.element.append(me.divWidget);
                        me.element.append(me.dropdownUL);
                        me._initDate();
                        me._updateDate(me.options.dateRange);
                        break;

                    case 3:

                        //##################### PARAGRAPHS ##################

                        me.pThisMonth = $("<p>").addClass("p-displaytext").html(this._getResources().thismonth);
                        me.pLastMonth = $("<p>").addClass("p-displaytext").html(this._getResources().lastmonth);
                        me.pMonthBefore = $("<p>").addClass("p-displaytext").html(this._getResources().monthbeforelastmonth);
                        me.pLastTwoMonths = $("<p>").addClass("p-displaytext").html(this._getResources().lasttwomonths);
                        me.pLastThreeMonths = $("<p>").addClass("p-displaytext").html(this._getResources().lastthreemonths);
                        me.pLastSixMonths = $("<p>").addClass("p-displaytext").html(this._getResources().lastsixmonths);

                        me.pDateStart = $("<p>").addClass("p-datestart vertical");
                        me.pDateEnd = $("<p>").addClass("p-dateend vertical");
                        me.pStartRange = $("<p>").addClass("p-range p-StartRangeI3").html(this._getResources().from);
                        me.pEndRange = $("<p>").addClass("p-range p-EndRangeI3").html(this._getResources().to);

                        //##################### DROP DOWN ###################

                        me.dropdownUL.addClass("range-month");

                        //##################### LIST ITEMS ##################

                        //There must be ids

                        me.liThisMonth = $("<li>").attr("id", "li-thismonth").addClass("ul-dropdown-li button-toggle")
                            .data("nav", { modus: "M", interval: 1 });
                        me.liLastMonth = $("<li>").attr("id", "li-lastmonth").addClass("ul-dropdown-li button-toggle")
                            .data("nav", { modus: "M", interval: 1 });
                        me.liMonthBefore = $("<li>").attr("id", "li-monthbefore").addClass("ul-dropdown-li button-toggle")
                            .data("nav", { modus: "M", interval: 1 });
                        me.liLastSevenDays = $("<li>").attr("id", "li-lastsevendaies").addClass("ul-dropdown-li button-toggle")
                            .data("nav", { modus: "M", interval: 2 });
                        me.liLastFourteenDays = $("<li>").attr("id", "li-lastfourteendaies")
                            .addClass("ul-dropdown-li button-toggle").data("nav", { modus: "M", interval: 3 });;
                        me.liLastThirtyDays = $("<li>").attr("id", "li-lastthirtydaies")
                            .addClass("ul-dropdown-li button-toggle").data("nav", { modus: "M", interval: 6 });
                        me.liRange = $("<li>").attr("id", "li-range").addClass("ul-dropdown-li");

                        //###################################################
                        me._initDate();
                        //##################### CUSTOM ######################

                        me.divcustomtext = $("<div>").addClass("div-customtext");
                        me.divcustomstart = $("<div>").addClass("div-custom");
                        me.divcustomend = $("<div>").addClass("div-custom");
                        me.divcustomApply = $("<div>").addClass("div-button-month").html("OK").button();

                        me.ulmonthstart = $("<ul>").addClass("ul ul-month-base ul-monthstart vertical");
                        me._fillMonthDdl(me.ulmonthstart, "ul-month-liI3start");

                        me.ulyearstart = $("<ul>").addClass("ul ul-year-base ul-yearstart vertical");
                        this._fillYearDdl(me.ulyearstart, me.options.dateRange.from, "DD.MM.YYYY", "ul-year-liI3start");

                        me.ulmonthend = $("<ul>").addClass("ul ul-month-base ul-monthend vertical");
                        me._fillMonthDdl(me.ulmonthend, "ul-month-liI3end");

                        me.ulyearend = $("<ul>").addClass("ul ul-year-base ul-yearend vertical");
                        this._fillYearDdl(me.ulyearend, me.options.dateRange.from, "DD.MM.YYYY", "ul-year-liI3end");


                        me.divPickRangeStart = $("<div>").addClass("div-PickRangeI3 div-PickRangeStartI3 vertical");
                        me.divPickRangeEnd = $("<div>").addClass("div-PickRangeI3 div-PickRangeEndI3 vertical");
                        me.divbuttoncustomrange = $("<div>").addClass("div-buttoncustomrangeI3").html(this._getResources().takeDateSelection).button();

                        //###################################################

                        //##################### APPEND AREA #################

                        me.divDopDownText.append(me.pDivText, me.calenderIcon);
                        me.dropdowndiv.append(me.divDopDownText);

                        me.divNext.append(me.iArrowRight);
                        me.divPrevious.append(me.iArrowLeft);

                        if (this.options.useNavigation === true) {
                            me.liLeft.append(me.divPrevious);
                            me.liContent.append(me.dropdowndiv);
                            me.liRight.append(me.divNext);
                        } else {
                            me.liContent.append(me.dropdowndiv);
                        }

                        me.ulMenue.append(me.liLeft, me.liContent, me.liRight);
                        //Add Paragraphs
                        me.liThisMonth.append(me.pThisMonth);
                        me.liLastMonth.append(me.pLastMonth);
                        me.liMonthBefore.append(me.pMonthBefore);
                        me.liLastSevenDays.append(me.pLastTwoMonths);
                        me.liLastFourteenDays.append(me.pLastThreeMonths);
                        me.liLastThirtyDays.append(me.pLastSixMonths);
                        //Range
                        me.divcustomtext.append(me.pMonth, me.pYear);
                        me.divcustomstart.append(me.ulmonthstart, me.ulyearstart);
                        me.divcustomend.append(me.ulmonthend, me.ulyearend);
                        me.divPickRangeStart.append(me.divcustomstart);
                        me.divPickRangeEnd.append(me.divcustomend);
                        me.divRangeHeader.append(me.divbuttoncustomrange, $("<div>").css("clear", "both"), me.pDateStart, me.pDateEnd, $("<div>").css("clear", "both"));


                        me.divRange.append(me.divRangeHeader, me.divPickRangeStart, me.divPickRangeEnd);
                        //Range Item for Dropdown UL
                        me.liRange.append(me.divRange, me.divcustomtext);
                        //Add List Items to Dropdown UL
                        me.dropdownUL.append(me.liThisMonth,
                            me.liLastMonth,
                            me.liMonthBefore,
                            me.liLastSevenDays,
                            me.liLastFourteenDays,
                            me.liLastThirtyDays,
                            me.liRange);
                        //Append to Widget

                        me.divWidget.append(me.ulMenue);
                        me.element.append(me.divWidget);
                        me.element.append(me.dropdownUL);
                        me._updateDate(me.options.dateRange);

                        $(me.ulmonthstart).find(':nth-child(' +
                            (moment(me.options.dateRange.from, "DD.MM.YYYY").month() + 1) +
                            ')').addClass("color-bg-primary");
                        $(me.ulyearstart).find('[value = ' + (moment(me.options.dateRange.from, "DD.MM.YYYY").year()) + ']')
                            .addClass("color-bg-primary");

                        $(me.ulmonthend).find(':nth-child(' +
                            (moment(me.options.dateRange.from, "DD.MM.YYYY").month() + 1) +
                            ')').addClass("color-bg-primary");
                        $(me.ulyearend).find('[value = ' + (moment(me.options.dateRange.from, "DD.MM.YYYY").year()) + ']')
                            .addClass("color-bg-primary");
                        break;

                    case 5:

                        //##################### PARAGRAPHS ##################


                        me.pThisYear = $("<p>").addClass("p-displaytext").html(this._getResources().thisyear);
                        me.pLastYear = $("<p>").addClass("p-displaytext").html(this._getResources().lastyear);
                        me.pYearBefore = $("<p>").addClass("p-displaytext").html(this._getResources().yearbeforelastyear);

                        me.pStartRange = $("<p>").addClass("p-range p-StartRangeI5").html(this._getResources().from);
                        me.pEndRange = $("<p>").addClass("p-range p-EndRangeI5").html(this._getResources().to);

                        //##################### DROP DOWN ###################
                        me.dropdownUL.addClass("range-year");

                        //##################### LIST ITEMS ##################

                        //There must be ids

                        me.liThisYear = $("<li>").attr("id", "li-thisyear").addClass("ul-dropdown-li button-toggle")
                            .data("nav", { modus: "Y", interval: 1 });
                        me.liLastYear = $("<li>").attr("id", "li-lastyear").addClass("ul-dropdown-li button-toggle")
                            .data("nav", { modus: "Y", interval: 1 });
                        me.liYearBefore = $("<li>").attr("id", "li-yearbefore").addClass("ul-dropdown-li button-toggle")
                            .data("nav", { modus: "Y", interval: 1 });
                        me.liRange = $("<li>").attr("id", "li-range").addClass("ul-dropdown-li");

                        //###################################################
                        me._initDate();
                        //##################### CUSTOM ######################

                        me.divcustomtext = $("<div>").addClass("div-customtext");
                        me.divcustomstart = $("<div>").addClass("div-custom");
                        me.divcustomend = $("<div>").addClass("div-custom");
                        //me.divcustomApply = $("<div>").addClass("div-button-month").html(this._getResources().takeDateSelection).button();

                        me.ulyearstart = $("<ul>").addClass("ul ul-year-base ul-yearstart vertical");
                        this._fillYearDdl(me.ulyearstart, me.options.dateRange.from, "DD.MM.YYYY", "ul-year-listart-I5");

                        me.ulyearend = $("<ul>").addClass("ul ul-year-base ul-yearend vertical");

                        this._fillYearDdl(me.ulyearend, me.options.dateRange.from, "DD.MM.YYYY", "ul-year-liend-I5");

                        me.divPickRangeStart = $("<div>").addClass("div-PickRangeStart vertical");
                        me.divPickRangeEnd = $("<div>").addClass("div-PickRangeEndI3 vertical");
                        me.divbuttoncustomrange = $("<div>").addClass("div-buttoncustomrangeI5").html(this._getResources().takeDateSelection).button();

                        //###################################################

                        //##################### APPEND AREA #################

                        me.divDopDownText.append(me.pDivText, me.calenderIcon);
                        me.dropdowndiv.append(me.divDopDownText);

                        me.divNext.append(me.iArrowRight);
                        me.divPrevious.append(me.iArrowLeft);

                        if (this.options.useNavigation === true) {
                            me.liLeft.append(me.divPrevious);
                            me.liContent.append(me.dropdowndiv);
                            me.liRight.append(me.divNext);
                        } else {
                            me.liContent.append(me.dropdowndiv);
                        }

                        me.ulMenue.append(me.liLeft, me.liContent, me.liRight);
                        //Add Paragraphs
                        me.liThisYear.append(me.pThisYear);
                        me.liLastYear.append(me.pLastYear);
                        me.liYearBefore.append(me.pYearBefore);
                        //Range
                        me.divcustomtext.append();
                        me.divcustomstart.append(me.ulyearstart);
                        me.divcustomend.append(me.ulyearend);
                        me.divPickRangeStart.append(me.divcustomstart);
                        me.divPickRangeEnd.append(me.divcustomend);
                        me.divRangeHeader.append(me.divbuttoncustomrange);



                        me.divRange.append(me.divRangeHeader, me.divPickRangeStart, me.divPickRangeEnd);
                        //Range Item for Dropdown UL
                        me.liRange.append(me.divRange);
                        //Add List Items to Dropdown UL
                        me.dropdownUL.append(me.liThisYear, me.liLastYear, me.liYearBefore, me.liRange);
                        //Append to Widget

                        me.divWidget.append(me.ulMenue);
                        me.element.append(me.divWidget);
                        me.element.append(me.dropdownUL);
                        me._updateDate(me.options.dateRange);

                        $(me.ulyearstart).find('[value = ' + (moment(me.options.dateRange.from, "DD.MM.YYYY").year()) + ']')
                            .addClass("color-bg-primary");
                        $(me.ulyearend).find('[value = ' + (moment(me.options.dateRange.from, "DD.MM.YYYY").year()) + ']')
                            .addClass("color-bg-primary");
                        break;

                    default:
                        break;
                }
                break;

            default:
                me.errorParagraph = $("<p>").attr("id", "p-error").html("Invalid Mode");
                me.element.append(me.errorParagraph);
                break;
        }

        //##################### EVENTS ######################################
        //Expand the Widget 
        // me._on(me.iDateIcon, { click: function () { me.showMenu() } });
        //me._on(me.pDivText, { click: function () { me.showMenu() } });

        me._on(me.liContent, { click: function () { me.showMenu() } });

        //Go next Intervall
        me._on(me.divNext,
            {
                click: function () {
                    var defaultDayDif = 0;
                    var nav;
                    switch (me.options.mode) {

                        case 'Single':
                            switch (me.options.interval) {

                                case 1:
                                    me._updateDate(moment(me.options.singleDate, "DD.MM.YYYY").add(1, 'days').toDate()
                                        .format("dd.MM.yyyy"));

                                    if (me.options.time) {
                                        me.options.singleDateTime = me.element.find(".select-time.single").val();
                                    }
                                    break;

                                case 3:
                                    if (moment(this.options.singleDate, "DD.MM.YYYY").isValid()) {
                                        me._updateDate(moment(me.options.singleDate, "DD.MM.YYYY").add(1, 'M').toDate()
                                            .format("MM.yyyy"));
                                    } else {
                                        me._updateDate(moment(me.options.singleDate, "MM.YYYY").add(1, 'M').toDate()
                                            .format("MM.yyyy"));
                                    }
                                    if (me.options.time) {
                                        me.options.singleDateTime = me.element.find(".select-time.single").val();
                                    }
                                    break;

                                case 5:
                                    me._updateDate(moment(me.options.singleDate, "DD.MM.YYYY").add(1, 'Y'));
                                    if (me.options.time) {
                                        me.options.singleDateTime = me.element.find(".select-time.single").val();
                                    }
                                    break;

                                default:
                                    break;
                            }
                            break;

                        case 'Range':
                            switch (me.options.interval) {
                                case 1:
                                    nav = me.element.find(".ul-selected").data("nav");

                                    if (typeof (nav) === "undefined") {
                                        nav = {}
                                        nav.modus = "days";
                                        //nav.interval = moment.duration(moment(me.options.dateRange.to, "DD.MM.YYYY").diff(moment(me.options.dateRange.from, "DD.MM.YYYY"), "days"));


                                        if (moment(me.options.dateRange.to, "DD.MM.YYYY").diff(moment(me.options.dateRange.from, "DD.MM.YYYY")) > 0) {
                                            defaultDayDif = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                                .diff(moment(me.options.dateRange.from, "DD.MM.YYYY"), "days");
                                        } else {
                                            defaultDayDif = 1;
                                        }

                                        nav.interval = defaultDayDif;


                                    }
                                    switch (nav.modus) {
                                        case 'week':
                                            me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                                .add(nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                                .add(nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            break;

                                        case 'M':
                                            me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                                .add(nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                                .add(nav.interval, nav.modus).endOf("M").toDate().format("dd.MM.yyyy");
                                            break;

                                        case 'days':
                                            me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                                .add(nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                                .add(nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            break;

                                        default:
                                            break;
                                    }

                                    if (me.options.time) {
                                        me.options.dateRange.time.from = me.element.find(".select-time.from").val();
                                        me.options.dateRange.time.to = me.element.find(".select-time.to").val();
                                    }

                                    me._updateDate(me.options.dateRange);
                                    break;
                                case 3:
                                    nav = $(".ul-selectedI3").data("nav");
                                    me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                        .add(nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                    me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                        .add(nav.interval, nav.modus).endOf("M").toDate().format("dd.MM.yyyy");

                                    me._updateDate(me.options.dateRange);
                                    break;
                                case 5:
                                    nav = $(".ul-selectedI5").data("nav");
                                    me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                        .add(nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                    me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                        .add(nav.interval, nav.modus).toDate().format("dd.MM.yyyy");

                                    me._updateDate(me.options.dateRange);
                                    break;
                            }
                            break;

                        default:
                            break;
                    }
                }
            });
        //Go to Previous Intervall
        me._on(me.divPrevious,
            {
                click: function () {


                    var nav;
                    var defaultDayDif = 0;
                    switch (me.options.mode) {

                        case 'Single':
                            switch (me.options.interval) {

                                case 1:
                                    me._updateDate(moment(me.options.singleDate, "DD.MM.YYYY").add(-1, 'days').toDate()
                                        .format("dd.MM.yyyy"));
                                    if (me.options.time) {
                                        me.options.singleDateTime = me.element.find(".select-time.single").val();
                                    }
                                    break;

                                case 3:
                                    if (moment(this.options.singleDate, "DD.MM.YYYY").isValid()) {
                                        me._updateDate(moment(me.options.singleDate, "DD.MM.YYYY").add(-1, 'M').toDate()
                                            .format("MM.yyyy"));
                                    } else {
                                        me._updateDate(moment(me.options.singleDate, "MM.YYYY").add(-1, 'M').toDate()
                                            .format("MM.yyyy"));
                                    }
                                    break;

                                case 5:
                                    me._updateDate(moment(me.options.singleDate, "DD.MM.YYYY").add(-1, 'Y'));
                                    break;

                                default:
                                    break;
                            }
                            break;

                        case 'Range':
                            switch (me.options.interval) {

                                case 1:
                                    nav = me.element.find(".ul-selected").data("nav");
                                    if (typeof (nav) === "undefined") {
                                        nav = {}
                                        nav.modus = "days";

                                        if (moment(me.options.dateRange.to, "DD.MM.YYYY").diff(moment(me.options.dateRange.from, "DD.MM.YYYY")) > 0) {
                                            defaultDayDif = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                                .diff(moment(me.options.dateRange.from, "DD.MM.YYYY"), "days");
                                        } else {
                                            defaultDayDif = 1;

                                        }
                                        nav.interval = defaultDayDif;

                                    }

                                    switch (nav.modus) {
                                        case 'week':
                                            me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                                .add(-nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                                .add(-nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            break;

                                        case 'M':
                                            me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                                .add(-nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                                .add(-nav.interval, nav.modus).endOf("M").toDate().format("dd.MM.yyyy");
                                            break;

                                        case 'days':
                                            me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                                .add(-nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                            me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                                .add(-nav.interval, nav.modus).toDate().format("dd.MM.yyyy");


                                            break;

                                        default:
                                            break;
                                    }

                                    if (me.options.time) {
                                        me.options.dateRange.time.from = me.element.find(".select-time.from").val();
                                        me.options.dateRange.time.to = me.element.find(".select-time.to").val();
                                    }
                                    me._updateDate(me.options.dateRange);
                                    break;
                                case 3:
                                    nav = $(".ul-selectedI3").data("nav");

                                    me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                        .add(-nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                    me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                        .add(-nav.interval, nav.modus).endOf("M").toDate().format("dd.MM.yyyy");

                                    me._updateDate(me.options.dateRange);
                                    break;
                                case 5:
                                    nav = $(".ul-selectedI5").data("nav");

                                    me.options.dateRange.from = moment(me.options.dateRange.from, "DD.MM.YYYY")
                                        .add(-nav.interval, nav.modus).toDate().format("dd.MM.yyyy");
                                    me.options.dateRange.to = moment(me.options.dateRange.to, "DD.MM.YYYY")
                                        .add(-nav.interval, nav.modus).toDate().format("dd.MM.yyyy");

                                    me._updateDate(me.options.dateRange);
                                    break;
                            }
                            break;

                        default:
                            break;
                    }
                }
            });
        // Set Today
        me._on(me.liToday,
            {
                click: function () {
                    me._updateDate(me.liToday.data("date"));
                }
            });
        // Set Yesterday
        me._on(me.liYesterday,
            {
                click: function () {
                    me._updateDate(me.liYesterday.data("date"));
                }
            });
        // Set Day before yesterday
        me._on(me.liDayBeforeYesterday,
            {
                click: function () {
                    me._updateDate(me.liDayBeforeYesterday.data("date"));
                }
            });

        //Set Weeks in Interval 1 on Modus Range 
        me._on(me.liThisWeek,
            {
                click: function () {
                    me._setWeek(0);
                    me._updateDate(me.options.dateRange, true);
                    me.liThisWeek.addClass("ul-selected").siblings().removeClass("ul-selected");
                }
            });
        me._on(me.liLastWeek,
            {
                click: function () {
                    me._setWeek(1);
                    me._updateDate(me.options.dateRange, true);
                    me.liLastWeek.addClass("ul-selected").siblings().removeClass("ul-selected");
                }
            });
        me._on(me.liWeekBefore,
            {
                click: function () {
                    me._setWeek(2);
                    me._updateDate(me.options.dateRange, true);
                    me.liWeekBefore.addClass("ul-selected").siblings().removeClass("ul-selected");
                }
            });

        //Set Months in Interval 1 and 3 on Modus Range
        me._on(me.liThisMonth,
            {
                click: function () {
                    me._setMonthRange(0);
                    me._updateDate(me.options.dateRange);
                    if (me.options.interval === 1) {
                        me.liThisMonth.addClass("ul-selected").siblings().removeClass("ul-selected");
                    } else {
                        me.liThisMonth.addClass("ul-selectedI3").siblings().removeClass("ul-selectedI3");
                    }
                }
            });
        me._on(me.liLastMonth,
            {
                click: function () {
                    me._setMonthRange(1);
                    me._updateDate(me.options.dateRange);
                    if (me.options.interval === 1) {
                        me.liLastMonth.addClass("ul-selected").siblings().removeClass("ul-selected");
                    } else {
                        me.liLastMonth.addClass("ul-selectedI3").siblings().removeClass("ul-selectedI3");
                    }
                }
            });
        me._on(me.liMonthBefore,
            {
                click: function () {
                    me._setMonthRange(2);
                    me._updateDate(me.options.dateRange);
                    if (me.options.interval === 1) {
                        me.liMonthBefore.addClass("ul-selected").siblings().removeClass("ul-selected");
                    } else {
                        me.liMonthBefore.addClass("ul-selectedI3").siblings().removeClass("ul-selectedI3");
                    }
                }
            });

        //Set Last Range for Interval 1 and 3 on Modus Range
        me._on(me.liLastSevenDays,
            {
                click: function () {
                    me._setRangeLast(me.liLastSevenDays.data("nav").interval, me.liLastSevenDays.data("nav").modus);
                    me._updateDate(me.options.dateRange);
                    me.liLastSevenDays.addClass("ul-selected").siblings().removeClass("ul-selected");
                }
            });
        me._on(me.liLastFourteenDays,
            {
                click: function () {
                    me._setRangeLast(me.liLastFourteenDays.data("nav").interval, me.liLastFourteenDays.data("nav").modus);
                    me._updateDate(me.options.dateRange);
                    me.liLastFourteenDays.addClass("ul-selected").siblings().removeClass("ul-selected");
                }
            });
        me._on(me.liLastThirtyDays,
            {
                click: function () {
                    me._setRangeLast(me.liLastThirtyDays.data("nav").interval, me.liLastThirtyDays.data("nav").modus);
                    me._updateDate(me.options.dateRange);
                    me.liLastThirtyDays.addClass("ul-selected").siblings().removeClass("ul-selected");
                }
            });

        //Set Years in Interval 5 on Modus Range
        me._on(me.liThisYear,
            {
                click: function () {
                    me._setYearRange(0);
                    me._updateDate(me.options.dateRange);
                    me.liThisYear.addClass("ul-selectedI5").siblings().removeClass("ul-selectedI5");
                }
            });
        me._on(me.liLastYear,
            {
                click: function () {
                    me._setYearRange(1);
                    me._updateDate(me.options.dateRange);
                    me.liLastYear.addClass("ul-selectedI5").siblings().removeClass("ul-selectedI5");
                }
            });
        me._on(me.liYearBefore,
            {
                click: function () {
                    me._setYearRange(2);
                    me._updateDate(me.options.dateRange);
                    me.liYearBefore.addClass("ul-selectedI5").siblings().removeClass("ul-selectedI5");
                }
            });

        //Custom input Button for Interval 1, 3 and 5 on Modus Single and Interval 1 on Modus Range(for KW(Kalenderwoche))
        me._on(me.divcustomApply,
            {
                click: function () {
                    switch (me.options.mode) {

                        case 'Single':
                            if (me.options.time) {
                                me.options.singleDateTime = me.element.find(".select-time.single").val();
                            }
                            switch (me.options.interval) {
                                case 1:
                                    var dTmp = moment(me.dateInput.val(), "DD.MM.YYYY", true).toDate();
                                    //Validate Input
                                    if (moment(dTmp, "DD.MM.YYYY", true).isValid()) {
                                        me._updateDate(moment(dTmp).format("DD.MM.YYYY"));
                                    } else {
                                        me.divcustomInput.addClass("error");
                                        me.divcustomInput.append(me.pErrorInput);
                                    }
                                    break;

                                case 3:
                                    me._updateDate(moment(new Date(me.ulyear.find(".color-bg-primary").val(),
                                        me.ulmonth.find(".color-bg-primary").val()),
                                        "MM.YYYY").toDate().format("MM.yyyy"));
                                    break;
                                case 5:
                                    me._updateDate(moment($(event.target).val(), "YYYY").date(1).month(0).toDate().format("yyyy"));
                                    break;
                                default: break;
                            }
                            break;

                        //case 'Range':
                        //    switch (me.options.interval) {

                        //    case 1:
                        //        me.options.dateRange.from = moment(new Date(), "DD.MM.YYYY").week(me.inputWeekofYear.val())
                        //            .startOf('week').add(1, 'days').toDate().format("dd.MM.yyyy");
                        //        me.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").week(me.inputWeekofYear.val())
                        //            .endOf('week').add(1, 'days').toDate().format("dd.MM.yyyy");
                        //        me._updateDate(me.options.dateRange);
                        //        break;
                        //    default:
                        //        break;
                        //    }
                        //    break;
                        //default:break;
                    }
                }
            });
        //Button for custom Selection for Interval 1, 3 and 5 on Modus Range
        me._on(me.divbuttoncustomrange,
            {
                click: function () {
                    var from, to;
                    me.pErrorInput.remove();
                    me.divRangeHeader.removeClass("error");
                    switch (me.options.mode) {

                        case 'Single':
                            break;

                        case 'Range':

                            switch (me.options.interval) {
                                case 1:
                                    me.pErrorInput.remove();
                                    me.divRangeHeader.removeClass("error");
                                    if (moment(me.inputStartRange.val(), "DD.MM.YYYY", true).isValid() &&
                                        moment(me.inputEndRange.val(), "DD.MM.YYYY", true).isValid()) {
                                        if (me.options.time) {
                                            me.options.dateRange.time.from = me.element.find(".select-time.from").val();
                                            me.options.dateRange.time.to = me.element.find(".select-time.to").val();
                                            me.options.dateTimeRange.from = me.element.find(".select-time.from").val();
                                            me.options.dateTimeRange.to = me.element.find(".select-time.to").val();
                                        }
                                        me.options.dateRange.from = me.inputStartRange.val();
                                        me.options.dateRange.to = me.inputEndRange.val();

                                        me._updateDate(me.options.dateRange);
                                    } else {
                                        me.divRangeHeader.addClass("error");
                                        me.divRangeHeader.append(me.pErrorInput);
                                    }
                                    break;
                                case 3:
                                    me.pErrorInput.remove();
                                    me.divRangeHeader.removeClass("error");
                                    from = moment(new Date(me.ulyearstart.find(".color-bg-primary").val(),
                                        me.ulmonthstart.find(".color-bg-primary").val(), 1),
                                        "DD.MM.YYYY").toDate();
                                    to = moment(new Date(me.ulyearend.find(".color-bg-primary").val(),
                                        me.ulmonthend.find(".color-bg-primary").val(), 1),
                                        "DD.MM.YYYY").toDate();
                                    if (moment(from, "DD.MM.YYYY").isSameOrBefore(moment(to, "DD.MM.YYYY"))) {
                                        me.options.dateRange.from = from.format("dd.MM.yyyy");
                                        me.options.dateRange.to = to.format("dd.MM.yyyy");

                                        me._updateDate(me.options.dateRange);
                                    } else {
                                        me.divRangeHeader.addClass("error");
                                        me.divRangeHeader.append(me.pErrorInput);
                                    }
                                    break;
                                case 5:
                                    from = moment(new Date(me.ulyearstart.find(".color-bg-primary").val(), 1, 1),
                                        "DD.MM.YYYY").toDate();
                                    to = moment(new Date(me.ulyearend.find(".color-bg-primary").val(), 1, 1),
                                        "DD.MM.YYYY").endOf("Y").toDate();
                                    if (moment(from, "DD.MM.YYYY").isSameOrBefore(to, "DD.MM.YYYY")) {
                                        me.options.dateRange.from = from.format("dd.MM.yyyy");
                                        me.options.dateRange.to = to.format("dd.MM.yyyy");

                                        me._updateDate(me.options.dateRange);
                                    } else {
                                        //  me.divRangeHeader.addClass("error");
                                        me.divRangeHeader.addClass("error");
                                        me.divRangeHeader.append(me.pErrorInput);
                                    }
                                    break;

                                default:
                                    break;
                            }
                            break;

                        default:
                            break;
                    }
                }
            });

        me._on(me.divcustomPicker,
            {
                change: function () {
                    //gwa
                    me.pDivText.html(me.divcustomPicker.val());

                    if (!me.options.time) {
                        me._updateDate(me.divcustomPicker.val());
                    } else {
                        this.options.singleDate = me.divcustomPicker.val();
                        this.dateInput.val(this.options.singleDate);
                    }
                }
            });

        //Highligts the selected year in the custom list
        me._on(".ul-year-li",
            {
                click: function (event) {
                    $(event.target).addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                    if (me.options.interval === 5 && me.options.mode === "Single") {
                        me.options.singleDate = moment(new Date($(event.target).val(), 0, 1)).format("DD.MM.YYYY");
                        if (me.options.time) {
                            me.options.singleDate.time = me.element.find(".select-time.single").val();
                        }
                        me._updateDate(me.options.singleDate);
                    }
                }
            });
        //Highlights the selected months/years in the custom list
        me._on(".ul li",
            {
                click: function (event) {
                    $(event.target).addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                }
            });

        //Hover Event for the i Arrows to navigate between the next and previous interval
        me._on(".icon-nav,.i-dateicon",
            {
                mouseover: function (event) {
                    $(event.target).addClass("color-font-primary");
                },
                mouseleave: function (event) {
                    $(event.target).removeClass("color-font-primary");
                }
            });

        //Hover Event for the i Arrows to navigate between the next and previous interval
        me._on(".ul li",
            {
                mouseover: function (event) {
                    $(event.target).addClass("button-toggle-active");
                },
                mouseleave: function (event) {
                    $(event.target).removeClass("button-toggle-active");
                }
            });


        me._on(me.divPickRangeStart, {
            click: function (e) {
                if (this.options.interval === 1 && this.options.mode === "Range") {
                    this.setCalendarWeek(e);
                }
            }
        });
        me._on(me.divPickRangeEnd, {
            click: function (e) {
                if (this.options.interval === 1 && this.options.mode === "Range") {
                    this.setCalendarWeek(e);
                }
            }
        });


        //Updates everything in the widget for Interval 1 on Modus Single
        me._on(me.divPickRangeStart,
            {
                change: function () {
                    if (moment(me.divPickRangeStart.val(), "DD.MM.YYYY")
                        .isSameOrBefore(moment(me.divPickRangeEnd.val(), "DD.MM.YYYY"))) {
                        me.pDivText.html(me.divPickRangeStart.val() + "<br/>" + me.divPickRangeEnd.val());
                        me.options.dateRange.from = me.divPickRangeStart.val();
                        me.options.dateRange.to = me.divPickRangeEnd.val();
                        me.inputStartRange.val(me.options.dateRange.from);

                        if (me.options.time) {
                            me.options.singleDateTime = me.element.find(".select-time.single").val();
                        }
                    } else {
                        me.divPickRangeStart.datepicker("setDate",
                            moment(me.divPickRangeEnd.val(), "DD.MM.YYYY").add(-1, 'days').toDate());
                        me.inputStartRange.val(moment(me.divPickRangeEnd.val(), "DD.MM.YYYY").add(-1, 'days').toDate()
                            .format("dd.MM.yyyy"));
                        me.pDivText.html(me.divPickRangeStart.val() + "<br/>" + me.divPickRangeEnd.val());
                    }
                }
            });
        //Updates everything in the widget for Interval 1 on Modus Single
        me._on(me.divPickRangeEnd,
            {
                change: function () {
                    if (moment(me.divPickRangeStart.val(), "DD.MM.YYYY")
                        .isSameOrBefore(moment(me.divPickRangeEnd.val(), "DD.MM.YYYY"))) {
                        me.pDivText.html(me.divPickRangeStart.val() + "<br/>" + me.divPickRangeEnd.val());
                        me.options.dateRange.from = me.divPickRangeStart.val();
                        me.options.dateRange.to = me.divPickRangeEnd.val();
                        me.inputEndRange.val(me.options.dateRange.to);

                        if (me.options.time) {
                            me.options.singleDateTime = me.element.find(".select-time.single").val();
                        }
                    } else {
                        me.divPickRangeEnd.datepicker("setDate",
                            moment(me.divPickRangeStart.val(), "DD.MM.YYYY").add(1, 'days').toDate());
                        me.inputEndRange.val(moment(me.divPickRangeStart.val(), "DD.MM.YYYY").add(1, 'days').toDate()
                            .format("dd.MM.yyyy"));
                        me.pDivText.html(me.divPickRangeStart.val() + "<br/>" + me.divPickRangeEnd.val());
                    }
                }
            });

        //###################################################################

        return this;
    },
    //##################### FUNCTIONS #######################################

    //Return Single Dates (Public)
    getDate: function () {
        var day;
        //console.log(this.options);
        switch (this.options.mode) {

            case "Single":


                switch (this.options.interval) {
                    case 1:
                        if (this.options.time) {
                            return {
                                "from": this.options.singleDate, "to": this.options.singleDate, "time": this.options.singleDateTime
                            }
                        }
                        return { "from": this.options.singleDate, "to": this.options.singleDate }
                    case 3:
                        if (this.options.time) {
                            if (moment(this.options.singleDate, "DD.MM.YYYY").isValid() === false) {
                                day = moment(this.options.singleDate, "MM.YYYY").date(1).toDate().format("dd.MM.yyyy");
                                return { "from": moment(day, "DD.MM.YYYY").startOf("month").format("DD.MM.YYYY"), "to": moment(day, "DD.MM.YYYY").endOf("month").format("DD.MM.YYYY"), "time": this.options.singleDateTime }
                            } else {
                                return { "from": moment(this.options.singleDate, "DD.MM.YYYY").startOf("month").format("DD.MM.YYYY"), "to": moment(this.options.singleDate, "DD.MM.YYYY").endOf("month").format("DD.MM.YYYY"), "time": this.options.singleDateTime }
                            }
                        }
                        if (moment(this.options.singleDate, "DD.MM.YYYY").isValid() === false) {
                            day = moment(this.options.singleDate, "MM.YYYY").date(1).toDate().format("dd.MM.yyyy");
                            return { "from": moment(day, "DD.MM.YYYY").startOf("month").format("DD.MM.YYYY"), "to": moment(day, "DD.MM.YYYY").endOf("month").format("DD.MM.YYYY") }
                        } else {
                            return { "from": moment(this.options.singleDate, "DD.MM.YYYY").startOf("month").format("DD.MM.YYYY"), "to": moment(this.options.singleDate, "DD.MM.YYYY").endOf("month").format("DD.MM.YYYY") }
                        }
                    case 5:
                        // return this.options.singleDate;
                        if (this.options.time) {
                            if (moment(this.options.singleDate, "DD.MM.YYYY").isValid() === false) {
                                this.options.singleDate = moment(new Date(this.options.singleDate, 1, 1)).format("DD.MM.YYYY");
                            }
                            return { "from": moment(this.options.singleDate, "DD.MM.YYYY").startOf("year").format("DD.MM.YYYY"), "to": moment(this.options.singleDate, "DD.MM.YYYY").endOf("year").format("DD.MM.YYYY"), "time": this.options.singleDateTime }
                        }
                        if (moment(this.options.singleDate, "DD.MM.YYYY").isValid() === false) {
                            this.options.singleDate = moment(new Date(this.options.singleDate, 1, 1)).format("DD.MM.YYYY");
                        }
                        return { "from": moment(this.options.singleDate, "DD.MM.YYYY").startOf("year").format("DD.MM.YYYY"), "to": moment(this.options.singleDate, "DD.MM.YYYY").endOf("year").format("DD.MM.YYYY") }
                    default:

                        return "";

                }
            case "Range":
                return this.options.dateRange;
        }
        return "";
    },

    //
    setSingleDate: function (sDate) {
        if (this.options.mode === "Single") {
            this.bActiveCallback = false;
            this._updateDate(sDate);
            this.bActiveCallback = true;
        }
    },


    //Return Ranges (Public)
    getDateRange: function () {
        return this.options.dateRange;
    },

    callback: function () {
        if (this.bActiveCallback) {
            if ($.isFunction(this.options.callback)) {
                this.options.returnDates = this.getDate();
                this.options.callback(this.options);
            }
        }
    },

    _fillYearDdl: function (obj, dt, dateFormat, cssClasses) {

     
        for (var i = 0; i < 20; i++) {
            obj.append($("<li>").attr("value", moment().year((moment(moment(), dateFormat).year() - 15) + i).format('YYYY'))
                .html(moment().year((moment(moment(), dateFormat).year() - 15) + i).format('YYYY')).addClass(cssClasses));
        }
    },

    _fillMonthDdl: function (obj, cssClasses) {
        for (var i = 0; i < 12; i++) {

            obj.append($("<li>").attr("value", i).html(this._getResources().months[i]).addClass(cssClasses));
        }
    },

    //Calls for SetDay
    _setToday: function () { return this._setDay(0); },
    _setYesterday: function () { return this._setDay(1); },
    _setDayBeforeYesterday: function () { return this._setDay(2); },

    //Dynamic function to set a single date with a parameter to add or remove a day or month or year depends on set Interval
    _setDay: function (interval) {

        var dDay = "";
        var me = this;
        switch (this.options.mode) {

            case "Single":
                switch (me.options.interval) {
                    case 1:
                        dDay = moment(new Date(), "DD.MM.YYYY").add(-interval, 'days').toDate().format("dd.MM.yyyy");
                        break;

                    case 3:
                        dDay = moment(new Date(), "DD.MM.YYYY").add(-interval, 'M').date(1).toDate().format("MM.yyyy");
                        break;

                    case 5:
                        dDay = moment(new Date(), "DD.MM.YYYY").add(-interval, 'Y').date(1).month(1).toDate().format("yyyy");
                        break;

                    default:
                        dDay = "";
                        break;
                }

        }
        return dDay;
    },

    //Sets weeks for Modus Range
    _setWeek: function (interval) {
        this.options.dateRange.from = moment(new Date(), "DD.MM.YYYY").add(-interval, 'weeks').startOf('week')
            .add(1, 'days').toDate().format("dd.MM.yyyy");
        this.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").add(-interval, 'weeks').endOf('week')
            .add(1, 'days').toDate().format("dd.MM.yyyy");
    },
    //Sets months for Modus Range
    _setMonthRange: function (interval) {
        this.options.dateRange.from = moment(new Date(), "DD.MM.YYYY").add(-interval, 'M').startOf('M').toDate()
            .format("dd.MM.yyyy");
        this.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").add(-interval, 'M').endOf('M').toDate()
            .format("dd.MM.yyyy");


    },
    //Sets years for Modus Range
    _setYearRange: function (interval) {
        var base = moment(new Date(), "DD.MM.YYYY").add(-interval, 'Y');

        this.options.dateRange.from = base.clone().startOf("Y").toDate().format("dd.MM.yyyy");

        // if this year is selected, the "to" date is today, otherwise it is the end of the year
        if (interval === 0) {
            this.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").toDate().format("dd.MM.yyyy");
        } else {
            this.options.dateRange.to = base.clone().endOf("Y").toDate().format("dd.MM.yyyy");
        }
    },
    //Sets defined range for Modus Range
    _setRangeLast: function (range, interval) {
        this.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").toDate().format("dd.MM.yyyy");
        this.options.dateRange.from = moment(new Date(), "DD.MM.YYYY").add(-range, interval).toDate()
            .format("dd.MM.yyyy");
    },




    //Sets first Date
    _initDate: function () {

        if (this.options.defaultDate != null || this.options.defaultRange.from != null && this.options.defaultRange.to != null) {
            switch (this.options.mode) {

                case 'Single':
                    if (this.options.defaultDate != null) {
                        this.options.singleDate = this.options.defaultDate;
                        this.options.singleDateTime = "00:00";
                    }
                    if (this.options.time && this.options.defaultDateTime != null) {
                        this.options.singleDateTime = this.options.defaultDateTime;
                    }
                    break;

                case 'Range':
                    if (this.options.defaultRange.from != null && this.options.defaultRange.to != null) {
                        switch (this.options.interval) {
                            case 1:

                                this.options.dateRange.from = moment(this.options.defaultRange.from, "DD.MM.YYYY").format("DD.MM.YYYY");
                                this.options.dateRange.to = moment(this.options.defaultRange.to, "DD.MM.YYYY").format("DD.MM.YYYY");

                                this.element.find(".ul-selected").data("nav", { modus: "days", interval: 1 });

                                this._updateDate(this.options.dateRange, true);

                                break;

                            case 3:

                                this.options.dateRange.from = moment(new Date(), "DD.MM.YYYY").startOf('M').toDate().format("dd.MM.yyyy");
                                this.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").endOf('M').toDate().format("dd.MM.yyyy");


                                break;

                            case 5:
                                this.options.dateRange.from = moment(this.options.defaultRange.from, "DD.MM.YYYY").startOf("Y").toDate().format("dd.MM.yyyy");
                                this.options.dateRange.to = moment(this.options.defaultRange.to, "DD.MM.YYYY").endOf("Y").toDate().format("dd.MM.yyyy");
                                break;

                            default:
                                break;
                        }

                    }
                    if (this.options.time && this.options.defaultTime.to != null) {
                        this.options.dateRange.time.to = this.options.defaultTime.to;
                    }
                    if (this.options.time && this.options.defaultTime.from != null) {
                        this.options.dateRange.time.from = this.options.defaultTime.from;
                    }
                    break;

                default:
                    break;
            }
        }
        else {
            switch (this.options.mode) {

                case 'Single':
                    switch (this.options.interval) {
                        case 1:
                            this.options.singleDate = moment(new Date()).format("DD.MM.YYYY");
                            break;
                        case 3:
                            this.options.singleDate = moment(new Date()).format("DD.MM.YYYY");
                            break;
                        case 5:
                            this.options.singleDate = moment(new Date()).format("YYYY");
                            break;
                        default:
                            break;
                    }
                    if (this.options.time) {
                        this.options.singleDateTime = "00:00";
                    }

                    break;

                case 'Range':
                    switch (this.options.interval) {
                        case 1:
                            this.options.dateRange.from = moment(new Date(), "DD.MM.YYYY").startOf('week').add(1, 'days').toDate().format("dd.MM.yyyy");
                            this.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").endOf('week').add(1, 'days').toDate().format("dd.MM.yyyy");
                            if (this.options.time) {
                                this.options.dateRange.time.from = "00:00";
                                this.options.dateRange.time.to = "00:00";
                                this.options.dateTimeRange.from = "00:00";
                                this.options.dateTimeRange.to = "00:00";
                            }
                            this.liThisWeek.addClass("ul-selected");
                            this._updateDate(this.options.dateRange, true);
                            break;

                        case 3:
                            this.options.dateRange.from = moment(new Date(), "DD.MM.YYYY").startOf('M').toDate().format("dd.MM.yyyy");
                            this.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").endOf('M').toDate().format("dd.MM.yyyy");
                            this.liThisMonth.addClass("ul-selectedI3");
                            this._updateDate(this.options.dateRange);
                            break;

                        case 5:
                            this.options.dateRange.from = moment(new Date(), "DD.MM.YYYY").startOf("Y").toDate().format("dd.MM.yyyy");
                            this.options.dateRange.to = moment(new Date(), "DD.MM.YYYY").endOf("Y").toDate().format("dd.MM.yyyy");
                            this.liThisYear.addClass("ul-selectedI5");
                            this._updateDate(this.options.dateRange);
                            break;

                        default:
                            break;
                    }
                    break;
                default:
                    break;
            }

        }
    },

    //Updates all elements in the Widget to the new set Date
    _updateDate: function (dSelected, weekofyear) {
        var pref = "";
        this.pDivText.removeClass("p-displaytext-linebreak p-displaytext-dates-linebreak");

        switch (this.options.mode) {
            case "Single":
                this.options.singleDate = dSelected;

                switch (this.options.interval) {
                    case 1:
                        if (this.options.time) {
                            this.options.singleDate.time = this.element.find(".select-time.single").val();
                        }
                        switch (this.options.singleDate) {

                            case this._setToday():
                                pref = $("<div>").addClass("p-displaytext p-divtext-sub").html(this._getResources().today);
                                this.pDivText.html("").addClass("p-displaytext-linebreak").append(pref, this.options.singleDate);

                                break;

                            case this._setYesterday():
                                pref = $("<div>").addClass("p-displaytext p-divtext-sub").html(this._getResources().yesterday);
                                this.pDivText.html("").addClass("p-displaytext-linebreak").append(pref, this.options.singleDate);
                                break;

                            //case this._setDayBeforeYesterday():
                            //    pref = $("<div>").addClass("p-displaytext p-divtext-sub").html(this._getResources().daybeforeyesterday);
                            //    this.pDivText.html("").addClass("p-displaytext-linebreak").append(pref, this.options.singleDate);
                            //    break;

                            default:
                                this.pDivText.html(this.options.singleDate);
                                break;
                        }
                        if (this.options.time) {
                            this.pDivText.append(" " + this.options.singleDateTime);
                        }
                        this.divcustomPicker.datepicker("setDate", moment(this.options.singleDate, "DD.MM.YYYY").toDate());
                        this.divcustomInput.removeClass("error");
                        this.pErrorInput.remove();

                        this.dateInput.val(this.options.singleDate);
                        break;

                    case 3:

                        switch (this.options.singleDate) {

                            case this._setToday(), this._setYesterday(), this._setDayBeforeYesterday():
                                // this.pDivText.html(this._getResources().thismonth + ": " + moment(this.options.singleDate, "MM.YYYY").toDate().format("MMM yyyy"));
                                this.pDivText.html(this._getResources().months[moment(this.options.singleDate, "MM.YYYY").toDate().format("MM") - 1] + " " + moment(this.options.singleDate, "MM.YYYY").toDate().format("yyyy"));
                                $(this.ulmonth).find('[value = ' + (moment(this.options.singleDate, "MM.YYYY").month()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                                $(this.ulyear).find('[value = ' + (moment(this.options.singleDate, "MM.YYYY").year()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                                break;
                            default:
                                if (moment(this.options.singleDate, "DD.MM.YYYY").isValid()) {
                                    this.pDivText.html(this._getResources().months[moment(this.options.singleDate, "DD.MM.YYYY").toDate().format("MM") - 1] + " " + moment(this.options.singleDate, "DD.MM.YYYY").toDate().format("yyyy"));
                                    $(this.ulmonth).find('[value = ' + (moment(this.options.singleDate, "DD.MM.YYYY").month()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                                    $(this.ulyear).find('[value = ' + (moment(this.options.singleDate, "DD.MM.YYYY").year()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                                }
                                else {
                                    this.pDivText.html(this._getResources().months[moment(this.options.singleDate, "MM.YYYY").toDate().format("MM") - 1] + " " + moment(this.options.singleDate, "MM.YYYY").toDate().format("yyyy"));
                                    $(this.ulmonth).find('[value = ' + (moment(this.options.singleDate, "MM.YYYY").month()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                                    $(this.ulyear).find('[value = ' + (moment(this.options.singleDate, "MM.YYYY").year()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                                }
                                break;
                        }
                        // $(this.ulmonth).find('[value = ' + (moment(this.options.singleDate, "MM.YYYY").month()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        // $(this.ulyear).find('[value = ' + (moment(this.options.singleDate, "MM.YYYY").year()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        break;

                    case 5:

                        if (moment(this.options.singleDate, "DD.MM.YYYY").isValid()) {
                            this.pDivText.html(moment(this.options.singleDate, "DD.MM.YYYY").toDate().format("yyyy"));
                        }
                        else {
                            this.pDivText.html(moment(this.options.singleDate, "YYYY").toDate().format("yyyy"));
                        }

                        var year;
                        if (this.options.singleDate.length > 4) {
                            year = moment(this.options.singleDate, "DD.MM.YYYY").year();
                        } else {
                            year = moment(this.options.singleDate, "YYYY").year();
                        }
                    
                        $(this.ulyear).find('[value = ' + year + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        break;

                    default:
                        this.errorParagraph = $("<p>").attr("id", "p-error").html("Invalid Mode");
                        this.element.append(this.errorParagraph);
                        break;
                }
                break;

            case "Range":

                switch (this.options.interval) {
                    case 1:
                        if (this.options.time) {
                            this.pDivText.addClass("p-displaytext-dates-linebreak").html(this.options.dateRange.from + " " + this.options.dateTimeRange.from + "<br/>" + this.options.dateRange.to + " " + this.options.dateTimeRange.to);
                        } else {
                            this.pDivText.addClass("p-displaytext-dates-linebreak").html(this.options.dateRange.from + "<br/>" + this.options.dateRange.to);
                        }
                        
                        this.inputStartRange.val(this.options.dateRange.from);
                        this.inputEndRange.val(this.options.dateRange.to);




                        this.divPickRangeStart.datepicker("setDate", moment(this.options.dateRange.from, "DD.MM.YYYY").toDate());
                        this.divPickRangeEnd.datepicker("setDate", moment(this.options.dateRange.to, "DD.MM.YYYY").toDate());
                        this.inputStartRange.removeClass("error-input");
                        this.inputEndRange.removeClass("error-input");
                        break;

                    case 3:
                        this.pDivText.addClass("p-displaytext-dates-linebreak").html(moment(this.options.dateRange.from, "DD.MM.YYYY").startOf("M").toDate().format("dd.MM.yyyy") + "<br/>" + moment(this.options.dateRange.to, "DD.MM.YYYY").endOf("M").toDate().format("dd.MM.yyyy"));
                        this.pDateStart.html(moment(this.options.dateRange.from, "DD.MM.YYYY").startOf("M").toDate().format("dd.MM.yyyy"));
                        this.pDateEnd.html(moment(this.options.dateRange.to, "DD.MM.YYYY").endOf("M").toDate().format("dd.MM.yyyy"));
                        $(this.ulyearstart).find('[value = ' + (moment(this.options.dateRange.from, "DD.MM.YYYY").year()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        $(this.ulmonthstart).find('[value = ' + (moment(this.options.dateRange.from, "DD.MM.YYYY").month()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        $(this.ulyearend).find('[value = ' + (moment(this.options.dateRange.to, "DD.MM.YYYY").year()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        $(this.ulmonthend).find('[value = ' + (moment(this.options.dateRange.to, "DD.MM.YYYY").month()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        this.pDateStart.removeClass("error-input");
                        this.pDateEnd.removeClass("error-input");
                        break;

                    case 5:
                        this.pDivText.html(moment(this.options.dateRange.from, "DD.MM.YYYY").year() + " - " + moment(this.options.dateRange.to, "DD.MM.YYYY").year());
                        $(this.ulyearstart).find('[value = ' + (moment(this.options.dateRange.from, "DD.MM.YYYY").year()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        $(this.ulyearend).find('[value = ' + (moment(this.options.dateRange.to, "DD.MM.YYYY").year()) + ']').addClass("color-bg-primary").siblings().removeClass("color-bg-primary");
                        break;

                    default:
                        break;
                }
                break;

            default:
                break;
        }

        if (!this.element.hasClass("vc-calendar-filter")) {
            this.dropdownUL.slideUp();
        }
       
        this.callback();
    },

    showMenu: function () {
        var me = this;
        me.pErrorInput.remove();
        me.divRangeHeader.removeClass("error");
        switch (me.options.mode) {

            case 'Single':
                if (me.options.interval >= 3) {
                    me.dropdownUL.slideToggle();
                    $(me.ulyear).scrollTop($(me.ulyear).find(".color-bg-primary").offset().top -
                        $(me.ulyear).offset().top +
                        $(me.ulyear).scrollTop());
                } else {
                    if (!me.divcustomInput.hasClass("error")) {
                        me.dropdownUL.slideToggle();
                    }
                }
                break;

            case 'Range':
                switch (me.options.interval) {
                    case 1:
                        if (!me.inputStartRange.hasClass("error-input") && !me.inputEndRange.hasClass("error-input")) {
                            me.dropdownUL.slideToggle();
                        }
                        break;

                    case 3:
                        me.dropdownUL.slideToggle();
                        $(me.ulyearstart).scrollTop($(me.ulyearstart).find(".color-bg-primary").offset().top -
                            $(me.ulyearstart).offset().top +
                            $(me.ulyearstart).scrollTop());
                        $(me.ulyearend).scrollTop($(me.ulyearend).find(".color-bg-primary").offset().top -
                            $(me.ulyearend).offset().top +
                            $(me.ulyearend).scrollTop());
                        break;

                    case 5:
                        me.dropdownUL.slideToggle();
                        $(me.ulyearstart).scrollTop($(me.ulyearstart).find(".color-bg-primary").offset().top -
                            $(me.ulyearstart).offset().top +
                            $(me.ulyearstart).scrollTop());
                        $(me.ulyearend).scrollTop($(me.ulyearend).find(".color-bg-primary").offset().top -
                            $(me.ulyearend).offset().top +
                            $(me.ulyearend).scrollTop());
                        break;

                    default:
                        me.dropdownUL.slideToggle();
                        break;
                }
                break;

            default:
                break;
        }
    },

    setCalendarWeek: function (e) {
        var me = this;
        if ($(e.originalEvent.target)[0].className === "ui-datepicker-week-col") {
            var year = $(e.currentTarget).find(".ui-datepicker-year")[0].innerHTML;
            var list = $.parseHTML(year);
            var y = 0;
            $.each(list, function () {
                if (this.selected === true) { y = parseInt(this.value); }
            });
            var cw = parseInt($(e.originalEvent.target)[0].innerHTML);

            me.options.dateRange.from = moment(new Date(y, 1, 1), "DD.MM.YYYY").week(cw)
                .startOf('week').add(1, 'days').toDate().format("dd.MM.yyyy");
            me.options.dateRange.to = moment(new Date(y, 1, 1), "DD.MM.YYYY").week(cw)
                .endOf('week').add(1, 'days').toDate().format("dd.MM.yyyy");
            me._updateDate(me.options.dateRange);
        }
    }
});
